import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import ActiveUsersTab from './ActiveUsersTab'
import DeletedUsersTab from './DeletedUsersTab'

export default function UsersTab ({ activeUsers, deletedUsers, deleteModal }) {
  return (
    <Tabs
      defaultActiveKey='active'
      items={[
        {
          label: t('Admin.UsersPage.tab.active'),
          key: 'active',
          children: <ActiveUsersTab activeUsers={activeUsers} deleteModal={deleteModal} />
        },
        {
          label: t('Admin.UsersPage.tab.deleted'),
          key: 'deleted',
          children: <DeletedUsersTab deletedUsers={deletedUsers} />
        }
      ]}
    />
  )
}
